import { useEffect, useRef } from 'react';

/**
 * Runs after a mounted card is rebound to a different mission.
 * Skips the first mount so a new card does not reset twice.
 */
export default function useOnTaskIdentity(taskId, onChange) {
  const seenRef = useRef(taskId);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  useEffect(() => {
    if (seenRef.current === taskId) return;
    seenRef.current = taskId;
    onChangeRef.current();
  }, [taskId]);
}
